<template>
  <base-modal :hide_footer="true" class="connection-modal">
    <template slot="title">
      {{ $t('pbx.worksheet.modal.create_relationship.title') }}
    </template>

    <template slot="description">
      {{ $t('pbx.worksheet.modal.create_relationship.content') }}
    </template>

    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';

  export default {
    components: { BaseModal }
  };
</script>

<style lang="scss">
  .connection-modal {
    &__row {
      display: flex;

      & + & {
        margin-top: $spacer;
      }

      .ivu-btn + .ivu-btn {
        margin-left: 10px;
      }

      .ivu-btn.ivu-btn-long {
        flex: 1 1 auto;
      }
    }
  }
</style>
